import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import { HomeUpdatedPackTick } from "../../../app-constants";
function Packages(props) {
  return (
    <section className="tekrevol__pack tekrevol__attend_workshop overflow-x-hidden p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="example example-bottom" data-text="Attend">
              <h2>
                Who Should Attend?
                <br className="d-xl-block d-none" />
                
              </h2>
              <p>This workshop is perfect for:</p>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center ">
          <Col
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={3}
            xxl={3}
            className="mb-xl-0 mb-4"
          >
            <div className="serv-item h-100">
              <div className="serv-inner tekrevol_gray_bg">
                <div className="sub-title">For</div>
                <div className="title">Entrepreneurs</div>
                <ul>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    Aspiring entrepreneurs looking to start their own business
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={3}
            xxl={3}
            className="mb-xl-0 mb-4"
          >
            <div className="serv-item h-100">
              <div className="serv-inner tekrevol_gray_bg">
                <div className="sub-title">For</div>
                <div className="title">Founders</div>
                <ul>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    Founders seeking investment and funding
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3} xxl={3} className="mb-sm-0 mb-4">
            <div className="serv-item h-100">
              <div className="serv-inner tekrevol_gray_bg">
                <div className="sub-title">For</div>
                <div className="title">Businesses </div>
                <ul>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    Established businesses wanting to refine their strategies.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3} xxl={3} className="">
            <div className="serv-item h-100">
              <div className="serv-inner tekrevol_gray_bg">
                <div className="sub-title">For</div>
                <div className="title">Professionals</div>
                <ul>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    Students and professionals eager to learn business planning skills.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Packages;
